import { useModal } from '@components/ModalHook';
import React from 'react';
import Modal from "./Modal";

export const MODAL_ID = 'POPUP_ZOOM_IMAGE';

const PopupZoomImage = () => {
  const [modalData, , hideModal] = useModal(MODAL_ID);
  
  let src = modalData.data?.src;
  
  return (
    <Modal 
      show={src ? true : false}
      close={hideModal}
    >
      <img src={src} />
    </Modal>
  )
}

export default PopupZoomImage;